export const MIXPANEL_EVENTS_SCAN = {
  SCAN_STARTED: 'scan_started',
  SCAN_COMPLETED: 'scan_completed',
  SCAN_ABORTED: 'scan_aborted'
}
